import React from 'react';

import {
  Logger,
} from 'aws-amplify';

import {
  Menu,
  MenuItem,
} from '@material-ui/core';

import { 
  default as Typography 
} from '../../utils/TypographyWithMargin';

const logger = new Logger('UserMenu');

export default function UserMenu(props) {

  const {
      menuId,
      userRole,
      selectedClientId,
      clients,
      anchorEl,
      open,
      onMenuClose,
      onSelectClient
  } = props;

  const selectClientHandler = (clientAccountId) => {
    logger.info("SELECT CLIENT:",clientAccountId);
    if(typeof onSelectClient !== 'undefined') {
        onSelectClient(clientAccountId);
    }
    if(typeof onMenuClose !== 'undefined') {
        onMenuClose();
    }
  };
  
  const getClientsByRole = (clients) => {
    
    let clientsByRoleList = [];
    if (clients) {
      let roleClientsMap={};
      Object.values(clients).forEach((client) => {
        if (!(client.EffectiveRole in roleClientsMap)) {
          roleClientsMap[client.EffectiveRole]=[];
        }
        roleClientsMap[client.EffectiveRole].push(client);
      });
      Object.keys(roleClientsMap).forEach((roleName) => {
        clientsByRoleList.push({ name: roleName, clients: roleClientsMap[roleName].sort((a,b)=>(a.ClientAccountAlias>b.ClientAccountAlias)?1:-1)});
      });
    }
    return clientsByRoleList;
  };

  const clientsByRole = getClientsByRole(clients);
  
  return (
    <Menu
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      onClose={onMenuClose}
      variant='selectedMenu'
    >
      {clientsByRole.map((role) => (
        <div key={role.name} >
          <MenuItem disabled={true}>
            <Typography
              color="textSecondary"
              display="block"
              variant="caption"
            >
              {role.name} in
            </Typography>
          </MenuItem>
          {userRole===role.name? ( 
            <MenuItem key='ALL' 
              dense={true} 
              selected={!selectedClientId}
              value='ALL'
              onClick={()=>selectClientHandler(null)}>Data Lake</MenuItem>
          ) : null}
          {role.clients.map((client) => (
            <MenuItem key={client.ClientAccountId} 
              dense={true} 
              selected={client.ClientAccountId === selectedClientId}
              onClick={()=>selectClientHandler(client.ClientAccountId)}
              >
                {client.ClientAccountAlias ? client.ClientAccountAlias : client.ClientAccountId}
            </MenuItem>
          ))}
        </div>
      ))}
    </Menu>
  );
}
